import {
  USER_LOGIN_LOADING,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
} from "../actionTypes/actionTypes";

const initialState = {
  data: {},
  loading: false,
  isLogged: false,
  error: "",
};

export const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_LOADING:
      return {
        ...state,
        loading: true,
      };

    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        isLogged: true,
      };

    case USER_LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
        isLogged: false,
        loading: false,
      };

    default:
      return state;
  }
};
